export enum HubloPoolDocumentType {
  CV = 'CV',
  DIPLOMA = 'DIPLOMA',
  IDENTITY_DOCUMENT = 'IDENTITY_DOCUMENT',
  IDENTITY_DOCUMENT_VERSO = 'IDENTITY_DOCUMENT_VERSO',
  RIB = 'RIB',
}

export type PoolDocument = {
  url: string
  name: string
  type: HubloPoolDocumentType
}
